// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1azKE","index":"styles_index__2zT8U"};